import { isValidQuestionnaireName } from '../../../utils/isValidQuestionnaireName'
import type {
  QuestionnaireStrategy,
  QuestionnaireSelectionResult,
  SelectionContext,
} from '../types'

/**
 * Strategy: Extract questionnaire from Monarch feature flags
 * Priority: Third (3rd)
 *
 * Behavior:
 * - Monarch still loading → continue to next strategy (will retry on next render)
 * - Monarch error → use 'default' and stop chain
 * - Valid questionSet from Monarch → use it and stop chain
 * - Invalid/missing questionSet → use 'default' and stop chain
 */
export const createMonarchStrategy = (): QuestionnaireStrategy => ({
  name: 'monarch',

  execute: (context: SelectionContext): QuestionnaireSelectionResult => {
    // If Monarch is still loading, wait for it
    if (context.monarchIsLoading) {
      return {
        questionnaire: null,
        shouldContinue: true,
        reason: 'Monarch still loading, will retry',
      }
    }

    if (context.monarchError) {
      return {
        questionnaire: 'default',
        shouldContinue: false,
        reason: 'Monarch error, using default',
      }
    }

    if (isValidQuestionnaireName(context.questionSet)) {
      return {
        questionnaire: context.questionSet,
        shouldContinue: false,
        reason: 'Valid questionSet from Monarch',
      }
    }

    return {
      questionnaire: 'default',
      shouldContinue: false,
      reason: 'Invalid/missing questionSet from Monarch, using default',
    }
  },

  isEnabled: () => true,
})
